export enum AppBarEnum {
  post = "Post",
}
